import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import AdminLoginPage from 'src/pages/admin/AdminLoginPage';

type AdminGuardProps = {
  children: React.ReactNode;
};

export default function AdminGuard({ children }: AdminGuardProps) {
  const adminAuth = useSelector((state: RootState) => state.adminAuth);

  if (!adminAuth.accessToken) {
    return <AdminLoginPage />;
  }

  return <>{children}</>;
}
